import React from "react";
import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import logo from "../images/svc-central-logo.jpg"; // SVC Central logo
import styles from "./pdfStyle.js"
import tableStyles from "./pdfStyle.js"
import { BRAND_NAME, COPYRIGHT_YEAR } from "../branding";

const MyDocument = ({ data }) => {
  const currentDate = new Date().toLocaleDateString();
  const currentTime = new Date().toLocaleTimeString();
  const labourCharges = data.labourCharges || [];
  const parts = data.parts || [];
  const customCharges = data.customCharges || [];
  const formattedTaskTime = data.formattedTaskTime || "0 secs";

  const totalProductAndServiceCost =
    labourCharges.reduce((sum, charge) => sum + parseFloat(charge.cost || 0), 0) +
    parts.reduce((sum, part) => sum + parseFloat(part.cost || 0), 0) +
    customCharges.reduce((sum, charge) => sum + parseFloat(charge.cost || 0), 0);

  const taxPercentage = parseFloat(data.taxPercentage) || 0;
  const taxAmount = totalProductAndServiceCost * (taxPercentage / 100);
  const totalCost = totalProductAndServiceCost + taxAmount;
  

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image src={logo} style={styles.logoDocument} />
          <View style={styles.billingInfo}>
            <Text style={styles.invoiceTitle}>INVOICE</Text>
            <Text style={styles.billingDetail}>REFERENCE: {data.invoiceNumber}</Text>
            <Text style={styles.billingDetail}>BILLING DATE: {currentDate}</Text>
            <Text style={styles.billingDetail}>BILLING TIME: {currentTime}</Text>
          </View>
        </View>
        <View style={styles.billingContainer}>
          <View style={styles.billingColumn}>
            <Text style={styles.subTitle}>BILLING FROM</Text>
            <View style={styles.customUnderline} />

            <Text style={styles.text}>{data.billingFrom?.sc_name}</Text>
            <Text style={styles.text}>{data.billingFrom?.sco_email}</Text>
            <Text style={styles.text}>{data.billingFrom?.address1}</Text>
            <Text style={styles.text}>{data.billingFrom?.address2}</Text>
            <Text style={styles.text}>
              {data.billingFrom?.city}, {data.billingFrom?.state}
            </Text>
            <Text style={styles.text}>{data.billingFrom?.zipcode}</Text>
          </View>
          <View style={styles.billingColumn}>
            <Text style={styles.subTitle}>BILLING TO</Text>
            <View style={styles.customUnderline} />

            <Text style={styles.text}>
              {data.billingTo?.first_name} {data.billingTo?.last_name}
            </Text>
            <Text style={styles.text}>Phone: {data.billingTo?.phone}</Text>
            <Text style={styles.text}>Email: {data.billingTo?.email}</Text>
            <Text style={styles.text}>
              {data.billingTo?.address1}, {data.billingTo?.address2}
            </Text>
            <Text style={styles.text}>
              {data.billingTo?.city}, {data.billingTo?.state}
            </Text>
            <Text style={styles.text}>{data.billingTo?.zipcode}</Text>
          </View>
        </View>

        <View style={tableStyles.table}>
          {/* Table Header */}
          <View style={tableStyles.tableHeader}>
            <Text style={tableStyles.tableText}>PRODUCT</Text>
            <Text style={tableStyles.tableText}>PRICE</Text>
          </View>

          {/* Table Rows for products and services */}
          {data.parts.map((part, index) => (
            <View key={index} style={tableStyles.tableRow}>
              <Text style={tableStyles.tableText}>
                {part.description}
                {"\n"}PART NUMBER: {part.number}
              </Text>
              <Text style={tableStyles.tableText}>${parseFloat(part.cost).toFixed(2)}</Text>
            </View>
          ))}

          {/* Rows for services */}
          {data.labourCharges.map((service, index) => (
            <View key={index} style={tableStyles.tableRow}>

              <Text style={tableStyles.tableText}>{service.description}</Text>
              <Text style={tableStyles.tableText}>${parseFloat(service.cost).toFixed(2)}</Text>
            </View>
          ))}

          {/* Rows for custom charges */}
          {customCharges.map((charge, index) => (
            <View key={`custom-${index}`} style={tableStyles.tableRow}>
              <Text style={tableStyles.tableText}>{charge.title}</Text>
              <Text style={tableStyles.tableText}>${parseFloat(charge.cost).toFixed(2)}</Text>
            </View>
          ))}

          {/* ... */}
          <View style={tableStyles.tableRow}>
            <Text style={tableStyles.tableText}>Tax ({taxPercentage}%)</Text>
            <Text style={tableStyles.tableText}>${parseFloat(taxAmount).toFixed(2)}</Text>
          </View>

          <View style={tableStyles.tableFooter}>
            <Text style={tableStyles.tableFooterText}>Total</Text>
            <Text style={tableStyles.tableFooterText}>${parseFloat(totalCost).toFixed(2)}</Text>
          </View>
        </View>
        {/* End of Table Section */}

        <View style={styles.section}>
          <Text style={styles.subTitleNC}>BILLING TIME</Text>
          <View style={styles.customUnderline} />
          <Text style={styles.text}>Time taken: {formattedTaskTime}</Text>

          <Text style={styles.subTitleNC}>WARRANTY INFORMATION</Text>
          <View style={styles.customUnderline} />

            <Text style={styles.warrantytext}>
              All Parts have manufacturer warranty of 2 years. Keep this invoice
              when claiming warranty.
            </Text>
          <Text style={styles.subTitleNC}>COMMENTS</Text>
          <View style={styles.customUnderline} />

          <Text style={styles.text}>{data.comments}</Text>
        </View>
        <View style={styles.footer}>
          <Text style={styles.pagetext}>Page 1 of 1</Text>
          <Text style={styles.copyrightText}>{`\u00A9 ${COPYRIGHT_YEAR} ${BRAND_NAME}`}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument;
